/**
 * Snowpad Geometric Logo — flat hexagon snowflake mark.
 * Use this component everywhere instead of the text "S" placeholder.
 */
export function SnowpadLogo({ size = 32 }: { size?: number }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-label="Snowpad logo"
      role="img"
    >
      {/* Hexagon background (pointy-top, radius 18) */}
      <polygon
        points="20,2 35.6,11 35.6,29 20,38 4.4,29 4.4,11"
        fill="#006780"
      />
      {/* Vertical snowflake arm */}
      <line
        x1="20" y1="7" x2="20" y2="33"
        stroke="white" strokeWidth="2.2" strokeLinecap="round"
      />
      {/* 60° arm */}
      <line
        x1="31.3" y1="13.5" x2="8.7" y2="26.5"
        stroke="white" strokeWidth="2.2" strokeLinecap="round"
      />
      {/* 120° arm */}
      <line
        x1="8.7" y1="13.5" x2="31.3" y2="26.5"
        stroke="white" strokeWidth="2.2" strokeLinecap="round"
      />
      {/* Inner connecting hexagon */}
      <polygon
        points="20,13 26.1,16.5 26.1,23.5 20,27 13.9,23.5 13.9,16.5"
        fill="none"
        stroke="white"
        strokeWidth="1.4"
        opacity="0.7"
      />
      {/* Center dot */}
      <circle cx="20" cy="20" r="2.8" fill="white" />
    </svg>
  );
}
